<template>
    <Card>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.products')">
                        <Autocomplete
                            url="/catalog/product-items"
                            :model-value="filters.products?.[0]?.uuid"
                            :selected-value="filters.products?.[0]?.name"
                            :can-be-empty="true"
                            @update:model-value="filters.products = $event !== null ? [$event] : []"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.warehouses')">
                        <Autocomplete
                            url="/management/warehouses"
                            :model-value="filters.warehouses?.[0]?.uuid"
                            :selected-value="filters.warehouses?.[0]?.name"
                            :can-be-empty="true"
                            @update:model-value="filters.warehouses = $event !== null ? [$event] : []"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <FetchTable
            :handle="tableHandle"
            url="/analytics/exit-declaration-statuses/products"
            v-model:orders="table.orders"
            :columns="table.columns"
        >
            <template #card-body-actions>
                <div class="row" style="width: 1000px">
                    <div class="col-lg-6">
                        <FormGroup :label="$t('labels.products')" class="mb-0">
                            <Autocomplete
                                url="/catalog/product-items"
                                :model-value="filters.products?.[0]?.uuid"
                                :selected-value="filters.products?.[0]?.name"
                                :can-be-empty="true"
                                @update:model-value="filters.products = $event !== null ? [$event] : []"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="$t('labels.warehouses')" class="mb-0">
                            <Autocomplete
                                url="/management/warehouses"
                                :model-value="filters.warehouses?.[0]?.uuid"
                                :selected-value="filters.warehouses?.[0]?.name"
                                :can-be-empty="true"
                                @update:model-value="filters.warehouses = $event !== null ? [$event] : []"
                            />
                        </FormGroup>
                    </div>
                </div>
            </template>
            <template v-for="exitDeclarationStatus in exitDeclarationStatuses" v-slot:[`th-${exitDeclarationStatus.uuid}`]>
                <span class="badge" :style="{'color': 'white', 'background-color': exitDeclarationStatus.color}">{{ exitDeclarationStatus.name }}</span>
            </template>
            <template #td-productImage="{row}">
                <img class="table-image" :src="row.fileUrl !== null ? row.fileUrl : PLACEHOLDER_IMAGE_URL" :alt="row.product.name"/>
            </template>
            <template #td-productName="{row}">
                <router-link
                    v-if="row.product.uuid"
                    class="long-string"
                    :to="{ name: 'EditProductPage', params: { productUuid: row.product.uuid } }"
                    :title="row.product.name"
                >
                    {{ row.product.name.length > 70 ? row.product.name.substring(0, 70) + '...' : row.product.name }}
                </router-link>
                <span v-else class="long-string" :title="row.product.name">
                    {{ row.product.name.length > 70 ? row.product.name.substring(0, 70) + '...' : row.product.name }}
                </span>
                <slot v-if="row.product.sku">
                    <span class="text-muted">{{ row.product.sku }}</span>
                </slot>
            </template>
            <template #td-warehouseName="{row}">
                <router-link :to="{ name: 'EditWarehousePage', params: { warehouseUuid: row.warehouse.uuid } }">{{ row.warehouse.name }}</router-link>
            </template>
            <template v-for="exitDeclarationStatus in exitDeclarationStatuses" v-slot:[`td-${exitDeclarationStatus.uuid}`]="{row}">
                {{ Amount.factory(row.balancesByStatusesUuid[exitDeclarationStatus.uuid]).toMeasurementString(row.product.measurement) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import Autocomplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Amount from '../../../../services/Amount';
import { PLACEHOLDER_IMAGE_URL } from '../../../constants';
import { httpClient } from '../../../../services/HttpClient';
export default {
    name: "ExitDeclarationStatusesIndexPage",
    components: {
        FetchTable, Autocomplete, FormGroup, Card
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            Amount,
            PLACEHOLDER_IMAGE_URL,
            table: {
                columns: [
                    {key: "warehouseName", name: this.$t('labels.warehouse_name'), width: "200px", type: "string", order: true},
                    {key: "productImage", name: this.$t('labels.product_image'), width: "150px", type: "string", order: false},
                    {key: "productName", name: this.$t('labels.product_name'), width: "300px", type: "string", order: true},
                ],
                orders: [],
            },
            exitDeclarationStatuses: [],
            filters: {
                products: [],
                warehouses: []
            }
        }
    },
    methods: {
        async fetchExitDeclarationStatuses() {
            const response = await httpClient.get('/management/exit-declaration-statuses', {
                limit: 0,
                orders: [{'column': 'order', 'dir': 'asc'}]
            })

            this.exitDeclarationStatuses = response.data.data

            this.table.columns = this.table.columns.concat(this.exitDeclarationStatuses.map((exitDeclarationStatus) => ({
                key: exitDeclarationStatus.uuid,
                name: exitDeclarationStatus.name,
                width: '150px',
                type: 'string',
                order: true
            })))
        },
        refreshTable() {
            this.tableHandle.page = 1
            this.tableHandle.fetchRows({
                productUuids: this.filters.products.map(product => product.uuid),
                warehouseUuids: this.filters.warehouses.map(warehouse => warehouse.uuid)
            })
        }
    },
    watch: {
        filters: {
            handler: function () {
                this.refreshTable()
            },
            deep: true
        }
    },
    async mounted() {
        await this.fetchExitDeclarationStatuses()
        this.refreshTable()
    }
}
</script>
<style scoped>
.table-image {
    max-width: 50px;
    max-height: 50px;
}
.long-string {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
